<ng-container>
  <div class="wrapper" [ngClass]="{'wrapper--icon': !!icon, 'wrapper--outline': outline}">
    <ui-icon *ngIf="icon" [nameIcon]="icon"></ui-icon>
    <ng-content></ng-content>
  </div>
</ng-container>

